// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__3yjWw","tab":"TabNav_tab__UsscY","link":"TabNav_link__1eDO2","selectedLink":"TabNav_selectedLink__3mHIB","disabled":"TabNav_disabled__zp0a0"};